import moment from "moment";
import { Line, Donut, StackedBar, StackedColumn } from "@antv/g2plot";
const colors = {};
export default {
  data() {
    return {
      plot: {
        line: null,
        donut: null,
        column: null,
        stack: null
      },
      plotData: {
        donut: null,
        line: null,
        stack: null,
        column: null
      },
      loading: {
        donut: true,
        line: true,
        stack: true,
        column: true
      }
    };
  },
  methods: {
    async line() {
      this.plot.line = new Line(this.$refs.line, {
        pincing: "auto",
        forceFit: true,
        data: this.plotData.line,
        xField: "date",
        yField: "value",
        yAxis: {
          label: {
            // 数值格式化为千分位
            formatter: v =>
              `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, s => `${s},`)
          }
        },
        interactions: this.getInteractions(),
        color: this.getColors(),
        legend: {
          position: "right-top"
        },
        smooth: false, //趋势是否平滑
        // point: {
        //   visible: true,
        //   shape: "circle",
        //   size: 3,
        //   style: {
        //     stroke: "#fff"
        //   }
        // },
        // label: {
        //   visible: true
        // },
        seriesField: "type",
        responsive: true
      });

      this.plot.line.render();
    },
    async donut() {
      this.plot.donut = new Donut(this.$refs.donut, {
        forceFit: true,
        label: {
          visible: true,
          type: "spider",
          formatter: v => {
            return `${v}小时`;
          }
        },
        color: this.getColors(),
        radius: 0.8,
        meta: {
          value: {
            alias: "时间",
            formatter: v => {
              return `${v}`;
            }
          }
        },
        pincing: "auto",
        data: this.plotData.donut,
        angleField: "value",
        colorField: "type",
        statistic: {
          visible: true,
          totalLabel: "已记录时间（小时）"
        }
      });

      this.plot.donut.render();
    },
    async stackBarPlot() {
      this.plot.stack = new StackedBar(this.$refs.stackDate, {
        forceFit: true,
        data: this.plotData.stack,
        yField: "category",
        xField: "duration",
        meta: {
          duration: {
            alias: "累计时间"
          }
        },
        label: {
          visible: true,
          formatter: v => `${v}小时`
        },
        stackField: "event"
      });

      this.plot.stack.render();
    },
    async column() {
      this.plot.column = new StackedColumn(this.$refs.StackedColumn, {
        forceFit: true,
        data: this.plotData.column,
        xField: "hour",
        yField: "duration",
        stackField: "type",
        color: this.getColors(),
        meta: {
          hour: {
            alias: "时段",
            formatter: v => {
              return `${v}:00`;
            }
          },
          duration: {
            alias: "累计时间（小时）"
          }
        }
      });

      this.plot.column.render();
    },
    async initColors() {
      const c = this.categorys;
      for (let id in c) {
        colors[c[id].name] = c[id].color;
      }
    },
    getColors() {
      if (this.type === "event") {
        return null;
      } else {
        return name => {
          return colors[name];
        };
      }
    },
    getInteractions() {
      const days = (this.end - this.start) / (24 * 60 * 60 * 1000);
      if (days < 30) return undefined;
      const percent = 30 / days;
      return [
        {
          type: "slider",
          cfg: {
            start: 1 - percent,
            end: 1
          }
        }
      ];
    },
    async getPlotData() {
      const logs = this.logs;
      const type = this.type;
      this.loading.column = true;
      this.loading.stack = true;
      this.loading.donut = false;
      this.loading.line = true;
      const lineData = [];
      const donutData = [];
      const stackData = [];
      const columData = [];
      const donutItem = {};
      const stackItems = {};
      const columItems = {};
      this.initColors();

      //Colum
      const incColumTime = (key, time, duration) => {
        const incTime = (key, hour, minute) => {
          if (columItems[key]) {
            columItems[key][hour] += minute;
          } else {
            columItems[key] = new Array(24).fill(0);
            columItems[key][hour] = minute;
          }
        };
        let hour = moment(time).hour();
        const recordMinute = moment(time).minute();
        const needMinute = 60 - recordMinute;

        //遍历该记录覆盖到的时段，添加时长
        if (duration > needMinute) {
          incTime(key, hour++, needMinute);
          duration -= needMinute;
        }

        while (duration > 60) {
          incTime(key, hour++, 60);
          duration -= 60;
        }

        //处理边界情况
        if (duration > 0) incTime(key, hour, duration);
      };
      const renderDataColum = () => {
        for (let key in columItems) {
          columItems[key].forEach((duration, hour) => {
            const str =
              type === "category" ? this.categorys[key] : this.events[key];
            columData.push({
              type: str ? str.name : "无标记",
              duration: duration / 60,
              hour
            });
          });
        }
      };

      //Stack
      const incStackTime = (category, event, duration) => {
        if (stackItems[category]) {
          if (stackItems[category][event]) {
            stackItems[category][event] += duration;
          } else {
            stackItems[category][event] = duration;
          }
        } else {
          stackItems[category] = {};
          stackItems[category][event] = duration;
        }
      };
      const renderDataStack = () => {
        for (let ca in stackItems) {
          for (let ev in stackItems[ca]) {
            const category = this.categorys[ca];
            const event = this.events[ev];
            stackData.push({
              category: category ? category.name : "未记录分类",
              event: event ? event.name : "未指定事件",
              duration: stackItems[ca][ev] / 60
            });
          }
        }
      };

      //Donut
      const incDonutTime = (key, duration) => {
        if (donutItem[key]) {
          donutItem[key] += duration / 60;
        } else {
          donutItem[key] = duration / 60;
        }
      };
      const renderDataDonut = () => {
        for (let key in donutItem) {
          const str =
            type === "category" ? this.categorys[key] : this.events[key];

          donutData.push({
            type: str ? str.name : "无标记时间",
            value: donutItem[key]
          });
        }
      };

      //Line
      const incLineTime = (item, id, duration) => {
        if (item[id]) {
          item[id] += duration / 60;
        } else {
          item[id] = duration / 60;
        }
      };
      const renderDataLine = (day, lineItems) => {
        for (let key in lineItems) {
          const str =
            type === "category" ? this.categorys[key] : this.events[key];

          lineData.push({
            date: moment(day).format("YYYY-MM-DD"),
            type: str ? str.name : "未指定事件",
            value: lineItems[key]
          });
        }
      };

      //遍历每一天
      for (let day = this.start; day <= this.end; day += 24 * 60 * 60 * 1000) {
        if (!logs[day] || logs[day].length === 0) continue; //如果没有记录则看下一个
        //Line
        let lineItems = {};

        logs[day].forEach(record => {
          const { category, event, duration, time } = record;
          const key = type === "category" ? category : event;

          //Line
          incLineTime(lineItems, key, duration);
          //Donut
          incDonutTime(key, duration);
          //Stack
          incStackTime(category, event, duration);
          //Colum
          incColumTime(key, time, duration);
        });

        //Line 渲染数据
        renderDataLine(day, lineItems);
      }

      //Donut 渲染数据
      renderDataDonut();

      //Stack 渲染数据
      renderDataStack();

      //Colum 渲染数据
      renderDataColum();

      this.plotData.line = lineData;
      this.plotData.column = columData;
      this.plotData.donut = donutData;
      this.plotData.stack = stackData;
    }
  },
  watch: {
    type() {
      this.initData();
    },
    "plotData.donut": function() {
      if (this.plot.donut) this.plot.donut.destroy();
      this.donut();
      this.loading.donut = false;
    },
    "plotData.line": function() {
      if (this.plot.line) this.plot.line.destroy();
      this.line();
      this.loading.line = false;
    },
    "plotData.stack": function() {
      if (this.plot.stack) this.plot.stack.destroy();
      this.stackBarPlot();
      this.loading.stack = false;
    },
    "plotData.column": function() {
      if (this.plot.column) this.plot.column.destroy();
      this.column();
      this.loading.column = false;
    }
  }
};
